// Layout, that contains navBar, header and main content of a page
// Used almost in every page in this project

import React, { ReactNode } from "react";
import { style } from "typestyle";

type PageLayoutProps = {
  navBar?: ReactNode;
  header?: ReactNode;
  content?: ReactNode;
  children?: ReactNode[];
};

const navBarHeight = "64px";
const FullScreenLayout = ({
  navBar,
  header,
  content,
  children,
}: PageLayoutProps) => (
  <div
    className={style({
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      flexDirection: "column",
      padding: `${navBarHeight} 0`,
    })}
  >
    {navBar && (
      <div
        className={style({
          width: "100%",
          position: "fixed",
          height: navBarHeight,
          top: "0",
          zIndex: 9999999,
        })}
      >
        {navBar}
      </div>
    )}
    {header && <div className={style({ width: "100%" })}>{header}</div>}
    {(content || children) && (
      <div
        className={style({
          position: "fixed",
          top: navBarHeight,
          bottom: "0",
          left: "0",
          right: "0",
        })}
      >
        {content || children}
      </div>
    )}
  </div>
);

export default FullScreenLayout;
